import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import BasicStand from './basic/BasicStand';
import IntermediateStand from './intermediate/IntermediateStand';
import FullStand from './fullStand/FullStand';
import apiConnect from '../../config/apiConfig';
import StandConfigMenu from './standConfig/StandConfigMenu';
import style from './stands.module.scss';

const Stand = () => {
  const { 
    container,
    containerRight,
    loadContainer,
    spin
  } = style;

  const [stand, setStand] = useState([]);
  const [images, setImages] = useState({});
  const [colorStand, setColorStand] = useState('');
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const iconSpin = <LoadingOutlined spin className={spin}/>;

  useEffect(() => {
    const getStand = async () => {
      try {
        setLoading(true);
        const { data } = await apiConnect.get(`/stands/${id}`);
        setStand(data.data[0]);
        setColorStand(data.data[0]?.standColor || 'Sin color');
        setLoading(false);
      } catch(error) {
        console.log(error); //eslint-disable-line
      }
    };

    getStand();
  }, []);


  const renderStand = () => {
    if(stand.type === 'standard') return <BasicStand setImages={setImages} images={images}/>;
    if(stand.type === 'intermediate') return <IntermediateStand setImages={setImages} images={images} colorStand={colorStand}/>;
    if(stand.type === 'full') return <FullStand stand={stand} setImages={setImages} images={images} colorStand={colorStand}/>;
  };

  return(
    <>
      {loading ? (
        <div className={container}>
          <div className={loadContainer}>
            <Spin indicator={iconSpin}/>
          </div>
        </div>
      ) : (
        <div className={container}>
          <StandConfigMenu
            stand={stand}
            images={images}
            colorStand={colorStand}
            setColorStand={setColorStand}
            id={stand._id}
          />
          <div className={containerRight}>
            { stand.type && renderStand() }
          </div>
        </div>
      )}
    </>
  );
};

export default Stand;